import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=e4b87bcc&scoped=true&"
import script from "./Paragraph.vue?vue&type=script&lang=js&"
export * from "./Paragraph.vue?vue&type=script&lang=js&"
import style0 from "./Paragraph.vue?vue&type=style&index=0&id=e4b87bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b87bcc",
  null
  
)

export default component.exports